<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="3" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" class="ml-2 mr-2" variant="outline-secondary"
                style="font-size: 0.675rem">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="3">
            <label>Date</label>
            <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
              :endDate="endDate" :locale-data="locale" @update="getSlineAccList('Normal', '0', '0', '1', '1')" />
          </b-col>
          <b-col md="2">
            <label>Common Filter</label>
            <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter" id="commonFilter"
              name="commonFilter" autocomplete="off" v-model="Filter.search_txt"
              @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
          </b-col>

          <b-col md="2">
            <label>Sline Filter</label>
            <model-list-select :list="$store.getters['common/getAllShippingLineList']" v-model="Filter.fk_sline_id"
              option-value="shippingId" option-text="shippingLine" placeholder="Select Shipping Line"
              @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
          </b-col>

          <b-col md="12">
            <b-button class="pull-right ml-1 mt-5 btn-sm" :variant="Filter.DateTypeFilter ||
              Filter.sa_account_no ||
              Filter.sa_ifsc ||
              Filter.search_txt ||
              Filter.fk_cu_id ||
              Filter.fk_uu_id ||
              Filter.fk_sline_id ||
              Filter.sa_is_active ||
              Filter.sa_is_deleted ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.sa_account_no ||
                  Filter.sa_ifsc ||
                  Filter.search_txt ||
                  Filter.fk_cu_id ||
                  Filter.fk_uu_id ||
                  Filter.fk_sline_id ||
                  Filter.sa_is_active ||
                  Filter.sa_is_deleted ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-5 btn-sm" v-if="getPaymentList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getPaymentList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
            <b-button variant="primary" @click="upserAccModal(null,'add')" class="pull-right ml-1 mt-5 btn-sm"
              style="font-size: 0.675rem">
              Add
            </b-button>
            <b-button v-if="$sessionsStorage.get('designation') == 'Admin'" class="pull-right ml-1 mt-5 btn-sm"
              variant="primary" @click="clearSlineAccount" :disabled="getPaymentList.length <= 0">

              <span v-if="!isClearSlineAccountProcessing">Clear Sline Accounts</span>
              <span v-else>
                <b-spinner small class="mr-2"></b-spinner>
                Processing...
              </span>
            </b-button>
            <b-form-group class="pull-right ml-1 mt-5 btn-sm">
              <b-button variant="primary" class="d-flex align-items-center" size="sm" style="font-size: 0.675rem"
                @click="triggerFileInput">
                <md-icon class="md-size-1x nav-icon mr-2">cloud_upload</md-icon>

                <div v-if="isFileLoading" class="d-flex align-items-center">
                  <span class="mr-2">Uploading...</span>
                  <b-spinner small></b-spinner>
                </div>
                <div v-else class="d-flex align-items-center">
                  Upload File
                </div>
              </b-button>
              <input ref="fileInput" type="file" class="d-none" @change="handleFileUpload" accept=".xlsx, .xls" />
            </b-form-group>
          </b-col>

          <b-col cols="9">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="3">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>

          <b-col cols="12">
            <div v-if="visible">
              <b-card>
                <b-collapse v-model="visible" id="collapse-2">
                  <b-row>
                    <b-col md="3">
                      <label>Date</label>
                      <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange"
                        :startDate="startDate" :endDate="endDate" :locale-data="locale"
                        :disabled="Filter.DFlag ? true : false"
                        @update="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>
                    <b-col md="3">
                      <label>Common Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                        id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.search_txt"
                        @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>
                    <b-col md="3">
                      <label>Sline Filter</label>
                      <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                        v-model="Filter.fk_sline_id" option-value="shippingId" option-text="shippingLine"
                        placeholder="Select Shipping Line" @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>
                    <b-col md="3">
                      <label>IFSC Code</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search IFSC Code"
                        id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.sa_ifsc"
                        @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>
                    <b-col md="3">
                      <label>Acc NO Filter</label>
                      <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Account No Filter"
                        id="commonFilter" name="commonFilter" autocomplete="off" v-model="Filter.sa_account_no"
                        @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>
                    <b-col md="3">
                      <label>Cretaed By</label>
                      <model-list-select :list="$store.getters['common/getAllUserList']" id="addedUserFilter"
                        v-model="Filter.fk_cu_id" option-value="userId" option-text="employeeName"
                        placeholder="Select Created User" @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>
                    <b-col md="3">
                      <label>Status</label>
                      <model-list-select :list="StatusList" v-model="Filter.sa_is_active" option-value="value"
                        option-text="text" placeholder="Select Status"
                        @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>
                    <b-col md="3">
                      <label>Delete Status</label>
                      <model-list-select :list="deleteStatusList" v-model="Filter.sa_is_deleted" option-value="value"
                        option-text="text" placeholder="Select Delete Status"
                        @input="getSlineAccList('Normal', '0', '0', '1', '1')" />
                    </b-col>

                    <b-col md="12" class="mt-2">
                      <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                        variant="outline-danger">Reset</b-button>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </div>
          </b-col>

          <b-col cols="12" class="table-responsive tableMain ">

            <b-table show-empty stacked="md" responsive :items="getPaymentList" :fields="PaymentAccountFields"
              primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
              class="position-relative">

              <template slot="SN" slot-scope="row0">
                <span>
                  {{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}

                </span>
              </template>
              <template slot="action" slot-scope="row0">
                <span v-if="row0.item.Status">Status:{{ row0.item.Status }}</span><br />
                <span v-if="row0.item.DeleteStatus">Delete Status:{{ row0.item.DeleteStatus }}</span><br />
                <span v-if="row0.item.CreatedBy">Created By:{{ row0.item.CreatedBy }}</span><br />
                <span v-if="row0.item.sa_created_at">Created At:{{ row0.item.sa_created_at }}</span><br />
                <span v-if="row0.item.UpdatedBy">Updated By:{{ row0.item.UpdatedBy }}</span><br />
                <span v-if="row0.item.sa_updated_at">Updated At:{{ row0.item.sa_updated_at }}</span><br />
                <b-button variant="primary" @click="upserAccModal(row0.item, 'edit')" class="btn-sm"
                  style="font-size: 0.675rem">
                  Update
                </b-button>
              </template>
            </b-table>
          </b-col>
          <b-col md="12">
            <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <b-modal id="upsert-sline-payment" ref="upsert-sline-payment"
      :title="(!form.sa_id || form.sa_id == 0) ? 'Add Payment Account' : 'Update Payment Account'" size="xl" no-close-on-esc
      no-close-on-backdrop hide-footer>
      <b-row>

        <b-col md="3">
          <b-form-group label="Shipping Line *" label-for="fk_sline_id">
            <model-list-select :list="$store.getters['common/getAllShippingLineList']" v-model="form.fk_sline_id"
              option-value="shippingId" option-text="shippingLine" placeholder="Select Shipping Line"
              :style="{ borderColor: !form.fk_sline_id && errorCustomPaymentValidation.fk_sline_id ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.fk_sline_id">{{ errorCustomPaymentValidation.fk_sline_id }}</span>
        </b-col>

        <!-- Account Name -->
        <b-col md="3" class="mb-3">

          <b-form-group label="Account Name *" label-for="sa_acc_name">
            <b-form-input id="sa_acc_name" v-model="form.sa_acc_name"
              :style="{ borderColor: !form.sa_acc_name && errorCustomPaymentValidation.sa_acc_name ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_acc_name">{{ errorCustomPaymentValidation.sa_acc_name }}</span>
        </b-col>

        <!-- Bank Name -->
        <b-col md="3" class="mb-3">
          <b-form-group label="Bank Name *" label-for="sa_bank_name">
            <b-form-input id="sa_bank_name" v-model="form.sa_bank_name"
              :style="{ borderColor: !form.sa_bank_name && errorCustomPaymentValidation.sa_bank_name ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_bank_name">{{ errorCustomPaymentValidation.sa_bank_name }}</span>
        </b-col>

        <!-- Account Type -->
        <b-col md="3" class="mb-3">

          <b-form-group label="Account Type *" label-for="sa_account_type">
            <model-list-select :list="accTypeList" v-model="form.sa_account_type" option-value="value"
              option-text="text" placeholder="Select Account Type"
              :style="{ borderColor: !form.sa_account_type && errorCustomPaymentValidation.sa_account_type ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_account_type">{{ errorCustomPaymentValidation.sa_account_type }}</span>

        </b-col>

        <!-- Contact Number -->
        <b-col md="3" class="mb-3">
          <b-form-group label="Contact Number" label-for="sa_contact_number">
            <b-form-input id="sa_contact_number" v-model="form.sa_contact_number"
              :style="{ borderColor: !form.sa_contact_number && errorCustomPaymentValidation.sa_contact_number ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_contact_number">{{ errorCustomPaymentValidation.sa_contact_number }}</span>
        </b-col>

        <!-- UPI ID -->
        <b-col md="3" class="mb-3">
          <b-form-group label="UPI ID" label-for="sa_upi_id">
            <b-form-input id="sa_upi_id" v-model="form.sa_upi_id"
              :style="{ borderColor: !form.sa_upi_id && errorCustomPaymentValidation.sa_upi_id ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_upi_id">{{ errorCustomPaymentValidation.sa_upi_id }}</span>
        </b-col>

        <!-- Currency (Assuming dropdown for relation) -->
        <b-col md="3" class="mb-3">
          <label>Currecny</label>
          <model-list-select :list="$store.getters['common/getAllCurrencyList']" v-model="form.fk_currency_id"
            option-value="currency_id" option-text="currencyCode" placeholder="Select Currency"
            :style="{ borderColor: !form.fk_currency_id && errorCustomPaymentValidation.fk_currency_id ? 'red' : '' }" />
          <span class="error" v-if="!form.fk_currency_id">{{ errorCustomPaymentValidation.fk_currency_id }}</span>
        </b-col>

        <!-- Branch -->
        <b-col md="3" class="mb-3">
          <b-form-group label="Branch" label-for="sa_branch">
            <b-form-input id="sa_branch" v-model="form.sa_branch"
              :style="{ borderColor: !form.sa_branch && errorCustomPaymentValidation.sa_branch ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_branch">{{ errorCustomPaymentValidation.sa_branch }}</span>
        </b-col>

        <!-- Address -->
        <b-col md="3" class="mb-3">
          <b-form-group label="Address" label-for="sa_address">
            <b-form-input id="sa_address" v-model="form.sa_address"
              :style="{ borderColor: !form.sa_address && errorCustomPaymentValidation.sa_address ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_address">{{ errorCustomPaymentValidation.sa_address }}</span>
        </b-col>

        <!-- Account Number -->
        <b-col md="3" class="mb-3">
          <b-form-group label="Account Number *" label-for="sa_account_no">
            <b-form-input id="sa_account_no" v-model="form.sa_account_no"
              :style="{ borderColor: !form.sa_account_no && errorCustomPaymentValidation.sa_account_no ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_account_no">{{ errorCustomPaymentValidation.sa_account_no }}</span>
        </b-col>

        <!-- IFSC -->
        <b-col md="3" class="mb-3">
          <b-form-group label="IFSC Code *" label-for="sa_ifsc">
            <b-form-input id="sa_ifsc" v-model="form.sa_ifsc"
              :style="{ borderColor: !form.sa_ifsc && errorCustomPaymentValidation.sa_ifsc ? 'red' : '' }" />
          </b-form-group>
          <span class="error" v-if="!form.sa_ifsc">{{ errorCustomPaymentValidation.sa_ifsc }}</span>
        </b-col>

        <b-col md="8" class=" mt-2">
          <b-button class="mr-2 btn-sm" variant="primary" @click="upsertAccount">

            <span v-if="!isAccProcessing">{{ form.sa_id == 0 ? 'Save' : 'Update' }}</span>
            <span v-else>
              <b-spinner small class="mr-2"></b-spinner>
              Processing...
            </span>
          </b-button>
          <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetModal">
            Close
          </b-button>
        </b-col>
      </b-row>
      <!-- You could also include item details here if needed -->
    </b-modal>

    <b-modal id="confirm-bulk-Sline-Account" ref="confirm-bulk-Sline-Account" title="Confirm Port Expense" size="xl"
      no-close-on-esc no-close-on-backdrop hide-footer>

      <b-row>
        <b-col cols="12">
          <h4 class="mt-3 error" v-if="errMSG && selectedRows.length > 0">{{ errMSG }} </h4>

        </b-col>

        <b-col md="12" v-if="selectedRows.length > 0">
          <b-table :items="selectedRows" :fields="confirmFields" small responsive head-variant="light">
            <template slot="SN" slot-scope="row0"><span>{{ row0.index + 1 }}</span></template>

          </b-table>
        </b-col>

        <b-col md="12" class=" mt-2" v-if="selectedRows.length > 0">
          <b-button class="mr-2 btn-sm" variant="primary" @click="getSlineImportData">
            <span v-if="!isBulkSlineAccountProcessing">Bulk Sline Account</span>
            <span v-else>
              <b-spinner small class="mr-2"></b-spinner>
              Processing...
            </span>
          </b-button>
          <b-button class="mr-2 btn-sm" variant="outline-danger" @click="resetConfirmModal">
            Cancel
          </b-button>
        </b-col>

      </b-row>

      <!-- You could also include item details here if needed -->
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-confirm :md-title="alert.title" :md-content="alert.content" :md-ok-text="alert.ok"
      @close="onConfirmClearSlineAccount" ref="confirmClearSlineAccount"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat, excelSerialToDate } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import SlineAccountServices from "../../services/SlineAccountServices";
import { read, utils, writeFile } from "xlsx";

export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      ),
    ];
    // Function to introduce a delay
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    // Wait for all store actions to complete
    Promise.all(storePromises)
      .then(() => delay(5000)) // Wait for 5 seconds
      .then(() => {
        // After the delay, execute the next function

      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getSlineAccList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      errMSG: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      ExcelBtnName1: "Export And Import",
      visible: false,
      getPaymentList: [],
      totalData: 0,
      accTypeList: [
        {
          value: 'Savings',
          text: 'Savings'
        },
        {
          value: 'Current',
          text: 'Current'
        }
      ],
      confirmFields: [
        { key: 'SN', label: 'SN' },
        { key: 'Sline', label: 'Shipping Line' },
        { key: 'sa_acc_name', label: 'Account Name' },
        { key: 'sa_bank_name', label: 'Bank Name' },
        { key: 'sa_branch', label: 'Branch' },
        { key: 'sa_address', label: 'Address' },
        { key: 'sa_account_no', label: 'Account No' },
        { key: 'sa_ifsc', label: 'IFSC Code' },
        { key: 'sa_contact_number', label: 'Contact No' },
        { key: 'sa_upi_id', label: 'UPI ID' },
      ],
      form: {
        sa_id: 0,
        sa_acc_name: '',
        fk_sline_id: "",
        sa_bank_name: '',
        sa_account_type: 'Current',
        sa_contact_number: '',
        sa_upi_id: '',
        fk_currency_id: '',
        sa_branch: '',
        sa_address: '',
        sa_account_no: '',
        sa_ifsc: '',
      },

      errorCustomPaymentValidation: {
        sa_acc_name: "",
        fk_sline_id: "",
        sa_bank_name: "",
        sa_account_no: "",
        sa_ifsc: "",
        sa_account_type: "",
        // fk_currency_id: "",
      },

      arrayErrorCustomValidation: [
        {
          sa_acc_name: "Enter Account Name",
          fk_sline_id: "Selecct Shipping Line Name",
          sa_bank_name: "Enter Bank Name",
          sa_account_no: "Enter Account No",
          sa_ifsc: "Enter IFSC Code",
          sa_account_type: "Selecct Account Type",
          // fk_currency_id: "Selecct Currecny",
        },
      ],


      validate: true,
      deleteStatusList: [
        { value: '0', text: 'Active' },
        { value: '1', text: 'Deleted' }],

      StatusList: [
        { value: '1', text: 'Active' },
        { value: '0', text: 'In-active' },
        { value: '2', text: 'All' },
      ],
      // Date format for datepickers

      dateFormat: { year: "numeric", month: "short", day: "numeric" },

      isAccProcessing: false,
      PaymentAccountFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "sa_account_no",
          mainkey: "sa_account_no",
          label: "Account No.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sa_ifsc",
          mainkey: "sa_ifsc",
          label: "IFSC Code.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sa_acc_name",
          mainkey: "sa_acc_name",
          label: "Account Name.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "Sline",
          mainkey: "Sline",
          label: "Sline",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "currencyCode",
          mainkey: "currencyCode",
          label: "Currency",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sa_bank_name",
          mainkey: "sa_bank_name",
          label: "Bank Name.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sa_branch",
          mainkey: "sa_branch",
          label: "Branch.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "sa_account_type",
          mainkey: "sa_account_type",
          label: "Account Type.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "sa_created_at",
          mainkey: "sa_created_at",
          label: "Created At.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: 'action',   // Our custom field name for checkboxes
          mainkey: "action",
          label: 'Action',         // No label, or you can put "Select"
          sortable: false,
          sortDirection: "ASC",
          table: "A.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        sa_account_no: "",
        sa_ifsc: "",
        search_txt: "",
        fk_cu_id: "",
        fk_uu_id: "",
        fk_sline_id: "",
        sa_is_active: "2",
        sa_is_deleted: "0",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
      ExpImpType: "0",
      isSubmited: false,
      isFileLoading: false,
      isBulkSlineAccountProcessing: false,
      isClearSlineAccountProcessing: false,
      selectedRows: [],
      confirm: {
        title: "Confirmation",
        content: "Are you sure you want to clear all Sline Accounts?",
        ok: "Yes",
        cancel: "No"
      },
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {

  },
  watch: {},
  methods: {
    upserAccModal(item,type) {
      this.clearFrom();
      if(type == 'edit') {
        this.form = item;

      }
      this.$refs["upsert-sline-payment"].show();
    },
    resetModal() {
      this.clearFrom();
      // Reset state each time modal is closed
      this.errMSG = "";
      this.$refs["upsert-sline-payment"].hide();
    },

    validateSlineAcc() {
      let validate_new = true;
      Object.keys(this.errorCustomPaymentValidation).map((x, index) => {
        if (
          this.form[x] == "" ||
          this.form[x] == 0 ||
          this.form[x] == undefined ||
          this.form[x] == null ||
          this.form[x] == "undefined" ||
          this.form[x] == "null"
        ) {
          this.errorCustomPaymentValidation[x] = this.arrayErrorCustomValidation[0][x];
          validate_new = false;
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    async upsertAccount() {
      this.validateSlineAcc();
      try {
        if (this.validate == true) {
          this.isAccProcessing = true; // Show loading indicator
          const response = await NodeLockPannelService.upsertPaymentAccountList(this.form)

          // Handle API response
          if (response.data.status) {
            this.resetModal();
            this.getSlineAccList("Normal", "0", "0", "1", "1");
            console.info(response.data.message || "Upsert Sline Account processed successfully.");
          } else {
            console.error(response.data.message || "Upsert Sline Account failed.");
          }
        }

      } catch (error) {
        console.error("Upsert Sline Account Error:", error);
        console.error("An error occurred while processing Shortlist Invoice.");
      } finally {
        this.isAccProcessing = false; // Hide loading indicator
      }
    },

    clearFrom() {
      this.form = {
        sa_id: 0,
        sa_acc_name: '',
        fk_sline_id: "",
        sa_bank_name: '',
        sa_account_type: 'Current',
        sa_contact_number: '',
        sa_upi_id: '',
        fk_currency_id: '',
        sa_branch: '',
        sa_address: '',
        sa_account_no: '',
        sa_ifsc: '',
      };
    },
    clearFilter() {

      this.Filter = {
        sa_account_no: "",
        sa_ifsc: "",
        search_txt: "",
        fk_cu_id: "",
        fk_uu_id: "",
        fk_sline_id: "",
        sa_is_active: "2",
        sa_is_deleted: "0",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getSlineAccList("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();

      // Subtract 1 day from today to get the previous day
      var previousDay = new Date();
      previousDay.setDate(today.getDate() - 1);

      // Format yesterday's date (DD/MM/YYYY)
      var prev_dd = String(previousDay.getDate()).padStart(2, "0");
      var prev_mm = String(previousDay.getMonth() + 1).padStart(2, "0");
      var prev_yyyy = previousDay.getFullYear();
      var startDate = `${prev_yyyy}/${prev_mm}/${prev_dd}`; // 11/02/2025

      // Format today's date (DD/MM/YYYY)
      var today_dd = String(today.getDate()).padStart(2, "0");
      var today_mm = String(today.getMonth() + 1).padStart(2, "0");
      var today_yyyy = today.getFullYear();
      var endDate = `${today_yyyy}/${today_mm}/${today_dd}`; // 12/02/2025

      // Set startDate and endDate
      this.startDate = startDate;
      // this.Filter.dateRange = {
      //   startDate: startDate, // 11/02/2025
      //   endDate: endDate,     // 12/02/2025
      // };
    },


    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async handleFileUpload(event) {
      const fileList = event.target.files;
      if (!fileList.length) return;

      // Excel Parsing
      const file = fileList[0];
      if (!file) return;

      this.parseExcelFile(file);
    },
    parseExcelFile(file) {
      const reader = new FileReader();
      this.isFileLoading = true;

      reader.onload = (e) => {
        const workbook = read(e.target.result, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        // const jsonData = utils.sheet_to_json(worksheet, { header: 1 });
        const jsonData = utils.sheet_to_json(worksheet, {
          header: 1,
          raw: false, // ⬅️ Forces cell formatting to string
        });

        // Now parse the data
        const parsedData = this.parseExcelData(jsonData);

        console.log('parsedData=>', parsedData)
        this.selectedRows = parsedData;
        this.openConfirmModal();
        this.isFileLoading = false;
      };

      reader.onerror = (error) => {
        console.error("File reading error:", error);
        this.isFileLoading = false;
      };

      reader.readAsBinaryString(file);
    },

    parseExcelData(rawData) {
      if (!Array.isArray(rawData) || rawData.length < 2) {
        return [];
      }

      const headers = rawData[0].map(header => header.trim());
      const rows = rawData.slice(1);

      const result = rows
        .filter(row => row && row.length > 0 && row.some(cell => cell !== undefined && cell !== null && cell !== ''))
        .map(row => {
          const obj = {};

          headers.forEach((header, index) => {
            const value = row[index];

            switch (header) {
              case "Shipping Line":
                obj.Sline = value ? value.toString() : '' || null;
                break;
              case "Account Name":
                obj.sa_acc_name = value ? value.toString() : '' || null;
                break;
              case "Bank Name":
                obj.sa_bank_name = value ? value.toString() : '' || null;
                break;
              case "Branch":
                obj.sa_branch = value ? value.toString() : '' || null;
                break;
              case "Address":
                obj.sa_address = value !== undefined ? (value).toString() : null;
                break;
              case "Account Number":
                obj.sa_account_no = value !== undefined ? (value).toString() : null;
                break;
              case "IFSC Code":
                obj.sa_ifsc = value !== undefined ? (value).toString() : null;
                break;
              case "Contact No":
                obj.sa_contact_number = value !== undefined ? (value).toString() : null;
                break;
              case "UPI ID":
                obj.sa_upi_id = value !== undefined ? (value).toString() : null;
                break;
              default:
                break;
            }
          });
          obj.fk_currency_id = 1;
          return obj;
        });

      return result;
    },

    getSlineImportData() {
      this.errMSG = "";
      let payload = { excel_data: this.selectedRows };
      if (this.selectedRows.length > 0) {
        this.isBulkSlineAccountProcessing = true;
        SlineAccountServices.upsertExcelBulkSlineAccount(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (response.data && response.data.error) {
              this.alert.content = response.data.error;
              this.$refs["addPop"].open();
            }

            if (status == 200 && data) {
              this.isBulkSlineAccountProcessing = false;
              this.selectedRows = [];
              this.resetModal();
              this.getSlineAccList("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getSlineImportData Error: ", error);
          });
      } else {
        console.log("PLease Choose Atleast One Correct Ledger List ");
      }
    },

    openConfirmModal() {
      this.$refs["confirm-bulk-Sline-Account"].show();
    },
    resetConfirmModal() {
      // Reset state each time modal is closed
      this.selectedRows = [];
      this.errMSG = "";
      this.$refs["confirm-bulk-Sline-Account"].hide();
    },

    clearSlineAccount() {
      if (this.getPaymentList.length > 0) {
        this.$refs.confirmClearSlineAccount.open(); // just open — no `.then()`
      } else {
        console.log("Please choose at least one valid Sline Account.");
      }
    },


    onConfirmClearSlineAccount(type) {

      if (this.getPaymentList.length > 0) {
        if (type == "ok") {
          this.isClearSlineAccountProcessing = true;
          SlineAccountServices.clearSlineAccount({})
            .then((response) => {
              const { data, status, statusText } = response;
              if (status == 200 && data) {
                this.isClearSlineAccountProcessing = false;
                this.getSlineAccList("Normal", "0", "0", "1", "1");
              }
              this.isLoading = false;
            })
            .catch((error) => {
              console.log("Catch on clearSlineAccount Error: ", error);
            });
        } else {
          console.log("Clear Sline Account cancelled by user.");
        }
      } else {
        console.log("Please Choose Atleast One Correct Sline Account List ");
      }
    },
    getSlineAccList(type, filterIdD, CURRENT, SEARCH, pageNumber) {

      this.totalData = 0;
      this.getPaymentList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllPaymentAccountList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              // Handle file download
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Sline-Accounts-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnName1 = "Export And Import";
              this.generateExcel = "0";
              this.ExpImpType = "0";
              this.getSlineAccList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.meta.totalSlineAccounts;
                this.getPaymentList = data.data;
                this.pagination.totalRows = data.meta.totalSlineAccounts;
                this.pagination.currentPage = data.meta.currentPage;
                this.pagination.perPage = data.meta.pageSize;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getPaymentList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getSlineAccList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExpImpType = "1";
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getSlineAccList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getSlineAccList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getSlineAccList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// slinePaymentAccountMaster.vue?4665b899